var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.evidences,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          selection: "multiple",
          selected: _vm.files_selected,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.requestEvidences,
          "update:selected": function($event) {
            _vm.files_selected = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _vm.files_selected.length > 0
                  ? _c("q-btn", {
                      staticClass: "q-mr-sm",
                      attrs: {
                        color: "negative",
                        icon: "fas fa-ban",
                        label: _vm.$t("remove"),
                        disable: _vm.disableEvidences
                      },
                      on: { click: _vm.removeEvidences }
                    })
                  : _vm._e(),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "fas fa-plus",
                    label: _vm.$t("add_evidence"),
                    disable: _vm.disableEvidences
                  },
                  on: {
                    click: function($event) {
                      _vm.add_evidence = true
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-th",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: {
                          "indeterminate-value": "some",
                          disable: _vm.disableEvidences
                        },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t(col.label)) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                {},
                [
                  _c(
                    "q-td",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: {
                          color: "primary",
                          disable: _vm.disableEvidences
                        },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _c("q-td", { key: "description", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$truncateLink(props.row.description)) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "file_url",
                      staticClass: "file-url",
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: props.row.file_url, target: "_blank" }
                        },
                        [_vm._v(_vm._s(_vm.$truncateLink(props.row.file_url)))]
                      )
                    ]
                  ),
                  _c("q-td", { key: "extension", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.extension) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "size", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.size) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "actions",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c("q-btn", {
                        attrs: {
                          round: "",
                          flat: "",
                          icon: "fas fa-trash",
                          color: "negative",
                          disable: _vm.disableEvidences
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeEvidence(props)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-esc-dismiss": "",
            "no-backdrop-dismiss": ""
          },
          model: {
            value: _vm.add_evidence,
            callback: function($$v) {
              _vm.add_evidence = $$v
            },
            expression: "add_evidence"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: { click: _vm.closeAddEvidence }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("evidences")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-xs" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("description"),
                          error: _vm.$v.description.$error
                        },
                        on: { input: _vm.$v.description.$touch },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row gutter-sm" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6" },
                        [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(_vm._s(_vm.$t("file")))
                          ]),
                          _c("uploader", {
                            attrs: {
                              multiple: false,
                              cropper: false,
                              disable: _vm.disableEvidences,
                              error: _vm.$v.file_url.$error
                            },
                            on: { fileUploaded: _vm.fileUploaded }
                          }),
                          _vm.file_url
                            ? _c(
                                "p",
                                { staticClass: "q-mt-md file-url" },
                                [
                                  _c("q-icon", {
                                    attrs: {
                                      name: "fas fa-check",
                                      color: "positive"
                                    }
                                  }),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.file_url,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$truncateLink(_vm.file_url)
                                          )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("back"),
                            icon: "fas fa-chevron-left"
                          },
                          on: { click: _vm.closeAddEvidence }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveFile()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }